/** @jsx h */
import { h } from 'preact'
import { useState } from 'preact/hooks'
import InfiniteModal from '../InfiniteModal'
import StoryCardListForInfiniteModal from './stories/StoryCardListForInfiniteModal'
import AboutCardForInfiniteModal from './about/AboutCardForInfiniteModal'
import CertificateCard from './CertificateCard'

const FullCertificateCard = ({
  data,
  data: { journeys, aboutTip }
}) => {
  const [openStoryIndex, setStoryOpen] = useState(-1)
  const [openAboutIndex, setAboutOpen] = useState(-1)

  const openStory = idx => e => {
    setStoryOpen(idx)
  }

  const closeStory = idx => e => {
    setStoryOpen(-1)
  }

  const openAbout = idx => e => {
    setAboutOpen(idx)
  }

  const closeAbout = idx => e => {
    setAboutOpen(-1)
  }

  const isStoryOpen = openStoryIndex > -1
  const isAboutOpen = openAboutIndex > -1

  return (
    <InfiniteModal class={`
    ${isStoryOpen ? 'InfiniteModal--revealStory' : 'InfiniteModal--concealStory'}
    ${isAboutOpen ? 'InfiniteModal--slideIn' : ''}
    `}
    >
      <CertificateCard {...data} journeys={journeys} onStoryClick={openStory} onAboutClick={openAbout} />

      <StoryCardListForInfiniteModal journeys={journeys} openStoryIndex={openStoryIndex} closeStory={closeStory} />
      <AboutCardForInfiniteModal aboutTip={aboutTip} reveal={isAboutOpen} closeAbout={closeAbout} />
    </InfiniteModal>
  )
}

export default FullCertificateCard
